import { Box } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { BoxForm, RadioGroup, Select } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Hint from 'components/Hint'
import { Link } from 'components/Link'
import Paper from 'components/Paper'
import { SelectOption } from 'components/Select'
import { useAccountTypeOptions } from '../../../hooks/useAccountTypeOptions'
import {
  PrebidModuleSlice,
  useGetPrebidModulesForSelect,
} from '../../../hooks/useGetPrebidModulesForSelect'
import { AddSchema } from '../../../schemas/addSchema'
import { SELECT_HINT_LEARN_MORE } from '../constants'
import { CommonFormProps } from '../types'

export const BasicAttributesSection = ({ variant }: CommonFormProps): JSX.Element => {
  const { t: tc } = useTranslation('common')
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'prebid.modules.userId.form.basicAttributes',
  })
  const accountTypeOptions = useAccountTypeOptions()
  const { control, watch } = useFormContext<AddSchema>()
  const { accountType } = watch()

  const { options } = useGetPrebidModulesForSelect({ moduleType: 'userId' })
  const filteredOptions = options.filter(
    (option: SelectOption<PrebidModuleSlice>): boolean => option.rawData?.account === accountType,
  )
  const disabled = variant === 'edit'

  return (
    <Paper>
      <SectionHeader
        subtitle={t('header.subtitle')}
        title={t('header.title')}
      />

      <GapBox />

      <BoxForm>
        <RadioGroup
          control={control}
          disabled={disabled}
          label={t('account.label')}
          name='accountType'
          options={accountTypeOptions}
          row
        />

        <Box>
          <Select
            control={control}
            disabled={disabled}
            label={t('prebidModuleId.label')}
            name='prebidModuleId'
            options={filteredOptions}
          />

          <Hint
            content={t('prebidModuleId.hint')}
            contentEndAdornment={
              <Link
                newTab
                to={SELECT_HINT_LEARN_MORE}
              >
                {tc('learnMore')}
              </Link>
            }
          />
        </Box>
      </BoxForm>
    </Paper>
  )
}
